// extracted by mini-css-extract-plugin
export default {"mnDownloadModal":"index_mnDownloadModal__sfT5K","mnDownload":"index_mnDownload__iZLYD"};